import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import "../Login/styles.css";
import { Col, Container, Row } from "react-bootstrap";
import { ReactComponent as LoginClocks } from "../../assets/Clocks.svg";
import { ReactComponent as LoginListeners } from "../../assets/ListenerBehaviour.svg";
import { ReactComponent as LoginMusic } from "../../assets/MusicAndContentTesting.svg";
import { ReactComponent as LogoSquare } from "../../assets/LogoSquareWhite.svg";
import Button from "react-bootstrap/Button";
import { useAuth } from "../../auth/Auth";

function Login() {
    const { token } = useAuth();
    const location = useLocation();

    //Redirect to home if we are already logged in
    if (token) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }
    const isLoginOrRelatedRoute =
        ["/login", "/login/", "/login/forgot_password"].includes(location.pathname) || location.pathname.startsWith("/login/reset_password/");

    return (
        <Container fluid className=" bg-ra-dark-blue d-flex flex-column">
            <Row className={`d-none ${isLoginOrRelatedRoute ? "d-xl-flex" : "d-none"}`}>
                <Col xs={12} className="p-0 text-end order-xl-first">
                    <Button onClick={() => window.open("https://musictest.pro/", "_blank")} size="sm" className=" btn-ra-yellow px-5">
                        Looking for Music Test by RadioAnalyzer? <strong>Login here</strong>
                    </Button>
                </Col>
            </Row>
            <Row className=" h-100">
                <Col xl={6} className="d-flex justify-content-center align-items-center mb-5">
                    <Col xs={10} sm={8} md={6} lg={5} xl={8} xxl={7} className=" h-100 d-flex flex-column justify-content-center">
                        <LogoSquare width={"70%"} className=" d-xl-none align-self-center my-5" />
                        <Outlet />
                    </Col>
                </Col>
                <Col xl={6} className="d-none d-xl-block align-self-center text-white">
                    <div className="d-flex justify-content-around  align-items-center w-75 my-2">
                        <LoginClocks width={"130px"} height={"130px"} className="mx-5"></LoginClocks>
                        <h2 className="w-50">Clocks & Airchecking </h2>
                    </div>
                    <hr className="line-break"></hr>
                    <div className="d-flex justify-content-around  align-items-center w-75 my-2">
                        <LoginMusic width={"150px"} height={"auto"} className="mx-4"></LoginMusic>
                        <h2 className="w-50">Music & Content Testing</h2>
                    </div>
                    <hr className="line-break"></hr>
                    <div className="d-flex justify-content-around align-items-center w-75 my-2">
                        <LoginListeners width={"189px"} height={"auto"} className="mx-4"></LoginListeners>
                        <h2 className="w-50">Listener Behaviour</h2>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <footer className="bg-beige text-dark p-1 fixed-bottom text-center terms row justify-content-center">
                        <Col xs={10}>
                            Use of this website constitutes acceptance of the RadioAnalyzer
                            <a
                                className="text-dark px-1 text-decoration-underline"
                                href="https://radioanalyzer.com/terms-conditions/"
                                rel="noreferrer"
                                target="_blank">
                                Terms and Conditions
                            </a>
                            and
                            <a className="text-dark text-decoration-underline px-1" href="https://radioanalyzer.com/privacy/" rel="noreferrer" target="_blank">
                                Privacy Notice.
                            </a>
                        </Col>
                    </footer>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
